import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrPage } from '../fr-page-layout/fr-page';
import { FrEventPageHeader } from '../fr-event-common-components/fr-event-page-header';
import { FREventPageFooter } from '../fr-event-common-components/fr-event-page-footer';
import { FrEventProviders } from '../fr-assigned-event-page/components/fr-event-providers';
import FrEventDetailsTabs from './components/fr-event-details-tabs';
import { useGetEventIdAndTabNameFromParams } from './hooks/use-get-event-id-and-tab-name-from-params';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrEventDetailsPage() {
    const { eventId, requestedTab } = useGetEventIdAndTabNameFromParams();
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrEventProviders eventId={eventId}>
            <FrPage>
                <FrEventPageHeader />
                {eventId && <FrEventDetailsTabs eventId={eventId} requestedTab={requestedTab} />}
                <FREventPageFooter hideMoreDetailsBtn />
            </FrPage>
        </FrEventProviders>
    );
}
